/**
 * Frontend JavaScript for Tool Detail Block - lightbox for images, contact form popup
 */
(function() {
	'use strict';

	function initContactPopup() {
		const triggers = document.querySelectorAll( '.tool-detail-contact-trigger' );
		triggers.forEach( function( btn ) {
			const block = btn.closest( '.wp-block-rssoftware-tool-detail-block' );
			if ( ! block ) return;
			const popup = block.querySelector( '.tool-detail-contact-popup' );
			if ( ! popup ) return;

			btn.addEventListener( 'click', function() {
				popup.setAttribute( 'aria-hidden', 'false' );
				popup.classList.add( 'tool-detail-contact-popup-visible' );
				document.body.style.overflow = 'hidden';
				popup.querySelector( '.tool-detail-contact-popup-close' ).focus();
			} );

			function closePopup() {
				popup.setAttribute( 'aria-hidden', 'true' );
				popup.classList.remove( 'tool-detail-contact-popup-visible' );
				document.body.style.overflow = '';
				btn.focus();
			}

			popup.querySelector( '.tool-detail-contact-popup-close' ).addEventListener( 'click', closePopup );
			popup.querySelector( '.tool-detail-contact-popup-overlay' ).addEventListener( 'click', closePopup );

			popup.addEventListener( 'keydown', function( e ) {
				if ( e.key === 'Escape' ) closePopup();
			} );
		} );
	}

	function initToolDetailLightbox() {
		const blocks = document.querySelectorAll( '.wp-block-rssoftware-tool-detail-block' );

		blocks.forEach( function( block ) {
			const imageSection = block.querySelector( '.tool-detail-image-section' );
			if ( ! imageSection ) return;

			// Collect images: main first, then gallery (in DOM order)
			const mainImg = imageSection.querySelector( '.tool-detail-image-wrapper .tool-detail-image' );
			const galleryImgs = imageSection.querySelectorAll( '.tool-detail-gallery-image' );

			const images = [];
			if ( mainImg && mainImg.src ) {
				images.push( { el: mainImg, src: mainImg.src } );
			}
			galleryImgs.forEach( function( img ) {
				if ( img.src ) {
					images.push( { el: img, src: img.src } );
				}
			} );

			if ( images.length === 0 ) return;

			// Make images clickable
			images.forEach( function( img, index ) {
				img.el.style.cursor = 'pointer';
				img.el.setAttribute( 'role', 'button' );
				img.el.setAttribute( 'tabindex', '0' );
				img.el.setAttribute( 'aria-label', 'View image ' + ( index + 1 ) + ' of ' + images.length );

				img.el.addEventListener( 'click', function( e ) {
					e.preventDefault();
					openLightbox( images, index );
				} );

				img.el.addEventListener( 'keydown', function( e ) {
					if ( e.key === 'Enter' || e.key === ' ' ) {
						e.preventDefault();
						openLightbox( images, index );
					}
				} );
			} );
		} );
	}

	function openLightbox( images, startIndex ) {
		if ( images.length === 0 ) return;

		// Remove existing lightbox
		const existing = document.getElementById( 'tool-detail-lightbox' );
		if ( existing ) existing.remove();

		let currentIndex = startIndex;

		const overlay = document.createElement( 'div' );
		overlay.id = 'tool-detail-lightbox';
		overlay.className = 'tool-detail-lightbox';

		overlay.innerHTML =
			'<button type="button" class="tool-detail-lightbox-close" aria-label="Close">&times;</button>' +
			'<div class="tool-detail-lightbox-content">' +
				'<button type="button" class="tool-detail-lightbox-prev" aria-label="Previous image">&lsaquo;</button>' +
				'<div class="tool-detail-lightbox-image-wrapper">' +
					'<img src="" alt="" class="tool-detail-lightbox-image" />' +
				'</div>' +
				'<button type="button" class="tool-detail-lightbox-next" aria-label="Next image">&rsaquo;</button>' +
			'</div>' +
			'<div class="tool-detail-lightbox-counter"></div>';

		const closeBtn = overlay.querySelector( '.tool-detail-lightbox-close' );
		const prevBtn = overlay.querySelector( '.tool-detail-lightbox-prev' );
		const nextBtn = overlay.querySelector( '.tool-detail-lightbox-next' );
		const img = overlay.querySelector( '.tool-detail-lightbox-image' );
		const counter = overlay.querySelector( '.tool-detail-lightbox-counter' );

		function showImage( index ) {
			currentIndex = ( index + images.length ) % images.length;
			img.src = images[ currentIndex ].src;
			img.alt = images[ currentIndex ].el.alt || '';

			prevBtn.style.visibility = images.length > 1 ? 'visible' : 'hidden';
			nextBtn.style.visibility = images.length > 1 ? 'visible' : 'hidden';

			counter.textContent = ( currentIndex + 1 ) + ' / ' + images.length;
		}

		function closeLightbox() {
			document.body.removeChild( overlay );
			document.body.style.overflow = '';
			document.removeEventListener( 'keydown', handleKeydown );
		}

		function handleKeydown( e ) {
			if ( e.key === 'Escape' ) {
				closeLightbox();
			} else if ( e.key === 'ArrowLeft' ) {
				e.preventDefault();
				if ( images.length > 1 ) showImage( currentIndex - 1 );
			} else if ( e.key === 'ArrowRight' ) {
				e.preventDefault();
				if ( images.length > 1 ) showImage( currentIndex + 1 );
			}
		}

		closeBtn.addEventListener( 'click', closeLightbox );
		overlay.addEventListener( 'click', function( e ) {
			if ( e.target === overlay ) closeLightbox();
		} );

		prevBtn.addEventListener( 'click', function( e ) {
			e.stopPropagation();
			if ( images.length > 1 ) showImage( currentIndex - 1 );
		} );

		nextBtn.addEventListener( 'click', function( e ) {
			e.stopPropagation();
			if ( images.length > 1 ) showImage( currentIndex + 1 );
		} );

		document.addEventListener( 'keydown', handleKeydown );
		document.body.style.overflow = 'hidden';
		document.body.appendChild( overlay );

		showImage( startIndex );
	}

	function init() {
		initToolDetailLightbox();
		initContactPopup();
	}

	if ( document.readyState === 'loading' ) {
		document.addEventListener( 'DOMContentLoaded', init );
	} else {
		init();
	}
})();
